import React from 'react';
import { ShieldOff } from 'lucide-react';
import { PanicButton } from './PanicButton';

/**
 * FloatingPanicButton — always-visible circular trigger anchored to
 * the TOP-RIGHT of the viewport so it (a) is reachable in one motion
 * from anywhere in the app, and (b) doesn't compete with the Emergent
 * "Made with" badge in the bottom-right or the bottom-left activity
 * banner. Tucked slightly in from the edge so a misclick near the
 * window chrome doesn't trigger it.
 *
 * The real confirmation / data-wipe dialog lives in the existing
 * `PanicButton` component — we just pass a custom trigger renderer.
 */
export const FloatingPanicButton = () => {
  return (
    <div
      className="fixed top-4 right-4 z-50 pointer-events-none"
      aria-hidden={false}
    >
      <div className="pointer-events-auto">
        <PanicButton
          renderTrigger={(open) => (
            <button
              onClick={open}
              title="Emergency data wipe"
              aria-label="Panic button — wipes all local data"
              data-testid="floating-panic-btn"
              className="group flex items-center gap-2 px-3 py-2 rounded-full bg-red-500/90 hover:bg-red-500 text-white shadow-xl shadow-red-500/30 ring-1 ring-red-300/40 backdrop-blur-sm transition-all duration-150 hover:scale-105 active:scale-95"
            >
              <ShieldOff className="w-4 h-4" />
              <span className="text-xs font-semibold tracking-wide uppercase hidden sm:inline">
                Panic
              </span>
            </button>
          )}
        />
      </div>
    </div>
  );
};

export default FloatingPanicButton;
